import { topMainPeople } from './index';

const topMain = () => {

  const pageTop = document.getElementById('pageTop');
  if (pageTop) {

    let sW = window.innerWidth;
    let sH = window.innerHeight;
    let header = document.querySelector('header.header');
    let secMain = document.getElementById('jsSecMain');

    let main = secMain.querySelectorAll('.js-main');
    let pin = secMain.querySelectorAll('.js-pin');
    let cloud = secMain.querySelectorAll('.js-cloud');
    let balloon = secMain.querySelector('.js-balloon');
    let peopleBox = secMain.querySelectorAll('.js-people-box');

    let copyBox = secMain.querySelectorAll('.js-copy-box');
    let leadBoxSpan = secMain.querySelectorAll('.js-lead-box span');

    if (!(sW > 750)) {
      let headerH = header.clientHeight
      secMain.style.height = `${sH - headerH}px`
    }

    gsap.set(copyBox, {
      width: 0,
    });

    gsap.set(leadBoxSpan, {
      y: '100%',
    });

    let mainGround = [
      main[0],
    ]
    let mainWood = [
      main[1],
      main[2],
      main[3],
      main[4],
      main[5],
    ]
    let mainBuilding = [
      main[6],
      main[7],
      main[8],
    ]
    let mainOther = [
      main[9],
      main[10],
    ]

    gsap.set(mainGround, {
      y: 20,
      opacity: 0,
    });
    gsap.set(mainWood, {
      y: 20,
      opacity: 0,
    });
    gsap.set(mainBuilding, {
      y: 20,
      opacity: 0,
    });
    gsap.set(mainOther, {
      y: 20,
      opacity: 0,
    });


    const mainAnime = () => {
      let tl = gsap.timeline()
      tl.to(mainGround, {
        y: 0,
        opacity: 1,
        duration: .5,
        ease: 'Power1.easeInOut',
      })
        .to(mainBuilding, {
          y: 0,
          opacity: 1,
          duration: .5,
          ease: 'Power1.easeInOut',
          stagger: {
            // amount: 0.5,
            each: 0.1,
            from: "random",
          },
        }, '+=0.5')
        .to(mainWood, {
          y: 0,
          opacity: 1,
          duration: .5,
          ease: 'Power1.easeInOut',
          stagger: {
            // amount: 0.3,
            each: 0.1,
            from: "random",
          },
        }, '+=0.1')
        .to(mainOther, {
          y: 0,
          opacity: 1,
          duration: .5,
          ease: 'Power1.easeInOut',
          stagger: {
            // amount: 0.2,
            each: 0.1,
            from: "random",
          },
          onComplete: () => {
            pinDrop()
            cloudAct()
            balloonAct()
            peopleAct()
            topMainPeople()
          },
        }, '<')
    }
    setTimeout(mainAnime, 1000)


    const pinDrop = () => {
      setTimeout(() => {
        for (let i = 0; i < pin.length; i++) {
          pin[i].classList.add('act')
        }
      }, 500)
      setTimeout(() => {
        copyBoxFunc()
      }, 1500)
    }


    const cloudAct = () => {
      cloud.forEach((element, index) => {
        setTimeout(() => {
          element.classList.add('act')
        }, 500 * index)
      });
    }


    const balloonAct = () => {
      setTimeout(() => {
        balloon.classList.add('act')
      }, 500)
    }


    const peopleAct = () => {
      setTimeout(() => {
        for (let i = 0; i < peopleBox.length; i++) {
          peopleBox[i].classList.add('act')
        }
      }, 500)
    }


    const copyBoxFunc = () => {
      let width;
      if (sW > 750) {
        width = '50%'
      } else {
        width = '100%'
      }
      gsap.to(copyBox, {
        width: width,
        duration: 1.4,
        stagger: 0.5,
        ease: "power1.out",
        onComplete: () => {
          leadBoxSpanFunc()
        },
      });
    }

    const leadBoxSpanFunc = () => {
      gsap.to(leadBoxSpan, {
        y: '0%',
        duration: 0.4,
        stagger: 0.08,
        ease: "power1.out",
        // onComplete: () => {
        //   pinRotate()
        // },
      });
    }







  }
};
export default topMain;